import React, { useEffect, useState } from "react";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts";
import usaJson from "./usa-map-data.json";
import { useMap } from "./useMap";
import styles from "./Map.module.scss";
type TJsonFormat = Parameters<typeof echarts.registerMap>[1];

const VehicleMapChart: React.FC = () => {
  const [chartOptions, setChartOptions] = useState<any>(null);
  const { vehicleSeries, vehiclesMap } = useMap();

  useEffect(() => {
    // Register the USA map
    echarts.registerMap("USA", usaJson as TJsonFormat, {
      Alaska: { left: -131, top: 25, width: 15 },
      Hawaii: { left: -110, top: 28, width: 5 },
      "Puerto Rico": { left: -76, top: 26, width: 2 },
    });

    // Base map configuration
    const baseOptions = {
      geo: {
        map: "USA",
        roam: false,
        zoom: 1.3,
        itemStyle: {
          borderColor: "#111",
          borderWidth: 1,
          color: "rgba(9, 116, 235, 0.5)",
        },
      },
      toolbox:
        vehicleSeries.length > 0
          ? {
              show: true,
              orient: "vertical",
              showTitle: "true",
              confine: "true",
              textStyle: {
                overflow: "breakAll",
                width: 40,
              },
            }
          : {},
      tooltip:
        vehicleSeries.length > 0
          ? {
              triggerLineEvent: true,
              trigger: "item",
              triggerOn: "click",
              enterable: true,
              formatter: (params: any) => {
                const data = params.data || {};
                const properties = data.properties || {};
                const count = properties.count || "N/A";
                const vehicleNames = properties.vehicles || [];
                const mappedVehicleNames = vehicleNames
                  .map((vehicle: any) => `<div>${vehicle}</div>`)
                  .join("");
                return `
          <div class="${styles.tooltip}">
            <strong>State:</strong> ${params.seriesName || "Unknown"}<br>
            <strong>Count:</strong> ${count}<br>
            <strong>Vehicles:</strong> <br>
            <div>
              ${mappedVehicleNames}
            </div>
          </div>
        `;
              },
            }
          : {},
      series: vehicleSeries.length > 0 ? vehicleSeries : [],
    };

    setChartOptions(baseOptions);
  }, [vehiclesMap]);

  return <ReactECharts option={chartOptions || {}} />;
};

export default VehicleMapChart;
